import { CSSProperties, ResponsiveStyleValue } from "theme-ui";
import { TextProps } from "./GetUpToSection";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import HeroButtons from "../Buttons/HeroButtons";
import SlantSection from "../Slant/Slant";
import { ButtonProps } from "../../../custom";
import BackgroundImage from "gatsby-background-image";

interface Props {
  backgroundColor: string;
  backgroundImage?: IGatsbyImageData;
  contentImage?: IGatsbyImageData;
  reverse?: boolean;
  logo?: IGatsbyImageData;
  backgroundPosition?: string | number | (string | number)[];
  buttonFlexDirection?: string;
  position?: "top" | "bottom";
  imagePosition?: string | number | (string | number)[];
  heroWidth?: string | number | (string | number)[];
  contentWidth?: string | number | (string | number)[];
  backgroundImageStyle?: CSSProperties;
  heroImage: IGatsbyImageData;
  subText?: TextProps;
  subHeader?: TextProps;
  linkText?: TextProps;
  heading: TextProps;
  alignCenter?: boolean;
  justifyCenter?: boolean;
  imageMarginTop?: boolean;
  button1: ButtonProps;
  button2: ButtonProps;
  className?: string;
  imageMaxWidth?: string | number | (string | number)[];
  customButton?: React.ReactNode;
  children?: React.ReactNode;
  showChildren?: boolean;
}

const HeroSection = ({
  heading,
  className,
  subText,
  heroImage,
  justifyCenter,
  contentImage,
  linkText,
  position,
  backgroundImageStyle,
  backgroundPosition,
  buttonFlexDirection,
  contentWidth = "50%",
  reverse,
  logo,
  button1,
  button2,
  alignCenter,
  backgroundColor,
  backgroundImage,
  subHeader,
  customButton,
  children,
  showChildren,
}: Props) => {
  const leftRight = reverse ? { left: 0 } : { right: 0 };
  const topBottom =
    position === "bottom" ? { bottom: [0, null, null, -100] } : { top: 0 };

  return (
    <BackgroundImage
      fluid={backgroundImage}
      sx={{
        zIndex: 9,
        position: "relative",
        mt: 100,
        height: [800, null, 1000, 700, null, 750],
        clipPath: "polygon(0 0, 100% 0%, 100% calc(100% - 5vw), 0 100%)",
        backgroundPosition: "top",
        "&::after": {
          backgroundPosition: "top!important",
          "@media screen and (max-width: 600px)": {
            backgroundPosition: "center!important",
          },
          "@media screen and (max-width: 1020px)": {
            backgroundPosition: backgroundPosition
              ? "top!important"
              : "bottom!important",
          },
        },
        ...backgroundImageStyle,
      }}
    >
      <div
        className={className}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",

          height: ["auto", null, null, "100%"],
          pt: [4, null, null, 0],
        }}
      >
        <div
          sx={{
            display: "flex",
            position: "relative",
            padding: 0,
            px: "0!important",
            pb: [backgroundImage ? 100 : 0, null, null, 100, 100],
            width: "100%",
            maxWidth: 1500,
            zIndex: 1,
            flexDirection: reverse ? "row-reverse" : "row",
            flexWrap: "wrap",
            overflow: "hidden",
          }}
        >
          <div
            sx={{
              width: ["100%", null, null, showChildren ? "100%" : contentWidth],
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {showChildren ? (
              <div
                sx={{
                  position: "relative",
                  width: "100%",
                  zIndex: 9,
                }}
              >
                {children}
              </div>
            ) : (
              <div
                data-sal={"slide-right"}
                data-sal-easing="easeOutQuart"
                data-sal-duration={1000}
                data-sal-delay="100"
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: alignCenter ? "center" : "flex-start",
                  justifyContent: justifyCenter ? "center" : "flex-start",
                  zIndex: 9,
                  position: "relative",
                  color: "white",
                  maxWidth: ["100%", null, null, 700],
                  // mt: [backgroundImage ? "5vw" : 0, null, null, "4vw"],
                  // mb: [backgroundImage ? "10vw" : "0", null, "6vw"],
                  // width: ["100%", null, null, "50%"],
                  pl: [3, null, null, reverse ? 0 : 5],
                  // pr: [3, null, null, reverse ? 5 : 0],
                }}
              >
                {logo && (
                  <GatsbyImage
                    image={logo}
                    alt="Logo"
                    objectFit="contain"
                    sx={{
                      maxHeight: [100, null, null, 250, 300],
                      mb: [3],
                      alignSelf: ["center", null, null, "center"],
                    }}
                  />
                )}
                {heading && (
                  <h1
                    sx={{
                      fontStyle: "italic",
                      my: 0,
                      color: [
                        heading.colorMobile
                          ? heading.colorMobile
                          : heading.color,
                        null,
                        null,
                        heading.color,
                      ],
                      textAlign: alignCenter ? "center" : "left",
                      sup: {
                        fontSize: 5,
                      },
                    }}
                    dangerouslySetInnerHTML={{ __html: heading.text }}
                  />
                )}
                {subHeader && (
                  <h2
                    sx={{
                      color: subHeader.color,
                      // pb: 0,
                    }}
                    dangerouslySetInnerHTML={{ __html: subHeader.text }}
                  />
                )}
                {subText && (
                  <p
                    sx={{
                      color: subText.color,
                      maxWidth: 600,
                    }}
                    dangerouslySetInnerHTML={{ __html: subText.text }}
                  />
                )}
                {!customButton && button1 && (
                  <HeroButtons
                    buttonFlexDirection={buttonFlexDirection || "row"}
                    button1={button1}
                    button2={button2}
                  />
                )}
                {customButton && customButton}
                {linkText && (
                  <p
                    sx={{
                      color: linkText.color,
                      mt: [-10, null, 15],
                      pb: [0, null, null, 4, 0],
                      fontWeight: 600,
                      a: {
                        fontSize: [18, null, null, 22],
                        color: "black",
                      },
                    }}
                    dangerouslySetInnerHTML={{ __html: linkText.text }}
                  />
                )}
                {contentImage && contentImage}
              </div>
            )}
          </div>
        </div>
      </div>
    </BackgroundImage>
  );
};

export default HeroSection;
